@if (showBadge) {
  <forge-badge [attr.theme]="theme">{{value}}</forge-badge>
}
